import type {
  GenericKeyboardEvent,
  VirtualScrollContextState as Props
} from '../types';

const useEventsHandler = ({
  currentIndex,
  dataRef,
  isFocused,
  setCurrentIndex,
  setIsFocused,
  virtuosoRef
}: Props) => {
  const scrollIntoView = (e: GenericKeyboardEvent, index: number) => {
    virtuosoRef.current?.scrollIntoView({
      index,
      behavior: 'auto',
      done: () => {
        if (!isFocused) {
          setIsFocused(true);
        }

        setCurrentIndex(index);
      }
    });

    e.preventDefault();
  };

  const handleKeyEvent = (e: GenericKeyboardEvent) => {
    let nextIndex: number | undefined;

    const data = dataRef.current;
    if (!data) return;

    if (e.shiftKey && e.code === 'Tab') {
      if (currentIndex <= -1) {
        setIsFocused(false);
        return;
      }

      nextIndex = currentIndex - 1;
    }

    if (!e.shiftKey && e.code === 'Tab') {
      if (currentIndex >= data.length) {
        setIsFocused(false);
        return;
      }

      nextIndex = currentIndex + 1;
    }

    if (nextIndex !== undefined) {
      scrollIntoView(e, nextIndex);
    }
  };

  return { handleKeyEvent };
};

export default useEventsHandler;
